/** @format */

import { HeaderCheckBoxSelectListElement } from './listTableHeader/HeaderCheckBoxSelectList';
import { ipStateIdMapInt } from './IpStateHelper';

const _ = require('underscore');

export const ipStateSimpleIdMapInt = {
    FREE: 0,
    USED: 1,
    IP_PRIVATE: 1,
    IP_PUBLIC: 0,
};

export const ipStateSimpleIdMapI18n = {
    FREE: 'pools:state.off',
    USED: 'pools:state.on',
};

export type StateIpToSimpleMapType = {
    stateId: number;
    simpleStateId: number;
};

export class IpTypeAddress {
    getStatus = (): Array<HeaderCheckBoxSelectListElement> => {
        return [
            { value: ipStateSimpleIdMapInt.IP_PRIVATE, name: 'pools:apn.header_private' },
            { value: ipStateSimpleIdMapInt.IP_PUBLIC, name: 'pools:apn.header_public' },
        ];
    };
}

export class IpStateSimpleHelper {
    public stateIpToSimpleMap: Array<StateIpToSimpleMapType> = [
        { stateId: ipStateIdMapInt.FREE, simpleStateId: ipStateSimpleIdMapInt.FREE },
        { stateId: ipStateIdMapInt.USED, simpleStateId: ipStateSimpleIdMapInt.USED },
        { stateId: ipStateIdMapInt.PLANNED, simpleStateId: ipStateSimpleIdMapInt.USED },
        { stateId: ipStateIdMapInt.LOCK, simpleStateId: ipStateSimpleIdMapInt.USED },
        { stateId: ipStateIdMapInt.ARCHIVE, simpleStateId: ipStateSimpleIdMapInt.USED },
    ];

    getHeaderList = (): Array<HeaderCheckBoxSelectListElement> => {
        return this.getStatus();
    };

    getStatus = (): Array<HeaderCheckBoxSelectListElement> => {
        return [
            { value: ipStateSimpleIdMapInt.FREE, name: ipStateSimpleIdMapI18n.FREE },
            { value: ipStateSimpleIdMapInt.USED, name: ipStateSimpleIdMapI18n.USED },
        ];
    };

    getName = (simpleStateId: number): string | null => {
        const obj = _.find(this.getStatus(), (item: HeaderCheckBoxSelectListElement) => {
            return simpleStateId === item.value;
        });
        if (obj) {
            return obj.name;
        }
        return null;
    };

    getNameByMap = (stateId: number): string | null => {
        const obj = _.find(this.stateIpToSimpleMap, (item: StateIpToSimpleMapType) => {
            return stateId === item.stateId;
        });
        if (obj) {
            return this.getName(obj.simpleStateId);
        }
        return null;
    };
}
